import React from 'react'
import './Shop.scss'

function Shop() {
  return (
    <div>Shop</div>
  )
}

export default Shop